var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg15(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 25,
    viewBox: "0 0 35 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33.5556,
    height: 25,
    transform: "translate(0.554688)",
    fill: "#FFC83C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6882 15.5H14.3701V10.9858H12.8307V10.11C13.237 10.0919 13.5214 10.0649 13.6839 10.0288C13.9427 9.97157 14.1534 9.85721 14.3159 9.68567C14.4273 9.5683 14.5115 9.41181 14.5687 9.21619C14.6018 9.09882 14.6184 9.01154 14.6184 8.95436H15.6882V15.5ZM19.8007 12.2498C19.6442 12.2498 19.5088 12.2693 19.3944 12.3084C19.1928 12.3807 19.0408 12.5146 18.9385 12.7102L17.7828 12.656L18.2433 9.04013H21.8502V10.1326H19.1732L18.9385 11.5636C19.1371 11.4342 19.2921 11.3484 19.4035 11.3063C19.59 11.2371 19.8173 11.2025 20.0851 11.2025C20.6268 11.2025 21.0993 11.3845 21.5026 11.7487C21.9058 12.1128 22.1075 12.6425 22.1075 13.3377C22.1075 13.9426 21.9134 14.4828 21.5251 14.9583C21.1369 15.4338 20.5561 15.6715 19.7827 15.6715C19.1597 15.6715 18.6481 15.5045 18.2478 15.1705C17.8476 14.8364 17.6248 14.3624 17.5797 13.7485H18.8617C18.9129 14.0284 19.0107 14.245 19.1552 14.3985C19.2996 14.549 19.5103 14.6242 19.7872 14.6242C20.1062 14.6242 20.3484 14.5129 20.514 14.2902C20.6825 14.0645 20.7668 13.7816 20.7668 13.4415C20.7668 13.1075 20.6885 12.8261 20.532 12.5973C20.3755 12.3656 20.1318 12.2498 19.8007 12.2498Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg15);
export default __webpack_public_path__ + "static/media/15.34f9ad15d78dc2acb8c09b832c6ea5d6.svg";
export { ForwardRef as ReactComponent };